<template>
  <v-dialog 
    v-model="dialog" 
    persistent
    max-width="800px">
    <v-fab-transition 
      v-if="item['.key']" 
      slot="activator">
      <v-btn 
        slot="activator" 
        fab
        dark
        small
        absolute
        bottom
        right
        color="secondary">
        <v-icon dark>edit</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition 
      v-else 
      slot="activator">
      <v-btn
        slot="activator" 
        color="secondary"
        fab
        dark
        absolute
        bottom            
        right
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-card>
      <v-form 
        ref="form" 
        v-model="valid"                 
        lazy-validation>
        <v-toolbar 
          
          color="primary" 
          dark>
          <v-toolbar-title>
            <span class="headline">{{ edititem.name ? edititem.name : 'New step' }}</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  :items="['Student','Organisation','Staff','Academic','Completed']"
                  :rules="[v => !!v || 'Step is required']"
                  v-model="item.type"
                  label="Actioned by"
                  required                      
                />
                <v-text-field
                  v-model="item.name"
                  :rules="nameRules"
                  :counter="100"
                  label="Name"                      
                  required
                />
              </v-flex>
            </v-layout>
          </v-container>
          <v-expansion-panel >
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>Alerts (optional)</div>
              </template>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex 
                    pt-4 
                    xs12>
                    Messages for the different user types viewing the placement at this current step
                  </v-flex>
                  <v-text-field
                    :class="item.type === 'Student' ? 'success' : 'info'" 
                    v-model="item.alertStudent"
                    :rules="alertRules"
                    :counter="200"
                    :prepend-icon="item.type === 'Student' ? 'edit' : 'info'"
                    dark
                    label="Student"
                    hint="Optional alert for Student viewing the 'Placement' at this step."
                    persistent-hint
                  />
                  <v-text-field
                    :class="item.type === 'Organisation' ? 'success' : 'info'" 
                    v-model="item.alertOrganisation"
                    :rules="alertRules"
                    :counter="200"
                    :prepend-icon="item.type === 'Organisation' ? 'edit' : 'info'"
                    dark
                    label="Organisation"
                    hint="Optional alert for Organisation viewing the 'Placement' at this step."
                    persistent-hint
                  />
                  <v-text-field
                    :class="item.type === 'Staff' ? 'success' : 'info'" 
                    v-model="item.alertStaff"
                    :rules="alertRules"
                    :counter="200"
                    :prepend-icon="item.type === 'Staff' ? 'edit' : 'info'"
                    dark
                    label="Staff"
                    hint="Optional alert for Staff viewing the 'Placement' at this step."
                    persistent-hint
                  />
                  <v-text-field
                    :class="item.type === 'Academic' ? 'success' : 'info'" 
                    v-model="item.alertAcademic"
                    :rules="alertRules"
                    :counter="200"
                    :prepend-icon="item.type === 'Academic' ? 'edit' : 'info'"
                    dark
                    label="Academic"
                    hint="Optional alert for Academic viewing the 'Placement' at this step."
                    persistent-hint
                  />
                </v-layout>
              </v-container>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>Emails (optional)</div>
              </template>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex 
                    pt-4 
                    xs12>
                    <div><v-icon>mail</v-icon><span class="title">Email notifications </span><span>(optional)</span></div>   
                  </v-flex>

                  <v-flex 
                    xs12 
                    sm4>
                    <v-checkbox 
                      v-model="item.emailStudent" 
                      label="Student"/>
                  </v-flex>
                  <v-flex 
                    xs12 
                    sm4>
                    <v-checkbox 
                      v-model="item.emailOrganisation" 
                      label="Organisation"/>
                  </v-flex>
                  <v-flex 
                    xs12 
                    sm4>
                    <v-text-field
                      v-model="item.emailOther"
                      :rules="emailRules"
                      label="Other email"
                    />                
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="item.emailSubject"
                      :rules="subjectRules"
                      label="Subject"
                      maxlength="75"
                      hide-details
                    />
                  </v-flex>
                  <v-flex xs12>
                    <ckeditor 
                      :editor="editor" 
                      v-model="item.emailMessage" 
                      :config="editorConfig"/>
                  </v-flex>
                </v-layout>            
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
            color="blue darken-1" 
            flat 
            @click.native="close">Close</v-btn>
          <v-btn 
            v-if="item['.key']" 
            color="red darken-1" 
            flat 
            @click.native="remove(item)">Delete</v-btn>    
          <v-btn 
            v-if="item['.key']" 
            color="blue darken-1" 
            flat 
            @click.native="update(item)">Update</v-btn>      
          <v-btn 
            v-else
            color="blue darken-1" 
            flat 
            @click.native="save(item)">Save</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { FirestoreUploadAdapter } from "@/plugins/FirestoreUploadAdapter";

function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = loader => {
    return new FirestoreUploadAdapter(loader);
  };
}

export default {
  name: "StepForm",
  props: {
    edititem: {
      type: [Array, Object],
      default: null
    },
    itemOrder: {
      type: Number,
      default: null
    }
  },
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      dialog: false,
      valid: true,
      // tabs: ["Main", "Alerts", "Emails"],
      // active: 2,
      nameRules: [
        v => !!v || "Required",
        v => (v && v.length <= 100) || "Text must be less than 100 characters"
      ],
      alertRules: [
        v => !v || v.length <= 200 || "Text must be less than 200 characters"
      ],
      subjectRules: [
        v => !v || v.length <= 75 || "Text must be less than 75 characters"
      ],
      /* messageRules: [
        v => !v || v.length <= 4000 || "Text must be less than 4000 characters"
      ],*/
      emailRules: [
        v =>
          !v ||
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) ||
          "Invalid e-mail."
      ],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "imageUpload",
          "blockQuote",
          "undo",
          "redo"
        ],
        extraPlugins: [MyCustomUploadAdapterPlugin]
      },
      item: JSON.parse(JSON.stringify(this.edititem))
    };
  },
  methods: {
    save(item) {
      if (this.$refs.form.validate()) {
        let self = this;
        this.dialog = false;
        this.$store.dispatch("setLoading", true);
        let itemOrder = this.itemOrder;
        this.$store.getters.db
          .collection("courses")
          .doc(this.$route.params.course)
          .collection("units")
          .doc(this.$route.params.unit)
          .collection("steps")
          .add({ ...item, itemOrder })
          .then(function() {
            console.log("Document successfully written!");
            self.$store.dispatch("sendNotification", {
              snackbar: true,
              color: "success",
              timeout: 6000,
              text: "Step" + itemOrder + " added"
            });
            self.$refs.form.reset();
            self.item = {};
            self.$store.dispatch("setLoading", false);
          })
          .catch(function(error) {
            console.error("Error writing document: ", error);
            self.$refs.form.reset();
            self.item = {};
            self.$store.dispatch("setLoading", false);
          });
      }
    },
    update(item) {
      if (this.$refs.form.validate()) {
        let self = this;
        this.dialog = false;
        let updateItem = JSON.parse(JSON.stringify(item));
        let key = updateItem[".key"];
        delete updateItem[".key"];
        delete updateItem["createdAt"];
        this.$store.dispatch("setLoading", true);
        this.$store.getters.db
          .collection("courses")
          .doc(this.$route.params.course)
          .collection("units")
          .doc(this.$route.params.unit)
          .collection("steps")
          .doc(key)
          .update(updateItem)
          .then(function() {
            console.log("Document successfully updated!");
            self.$store.dispatch("sendNotification", {
              snackbar: true,
              color: "success",
              timeout: 6000,
              text: "Step updated"
            });
            self.$store.dispatch("setLoading", false);
          })
          .catch(function(error) {
            console.error("Error writing document: ", error);
            self.$store.dispatch("setLoading", false);
          });
      }
    },
    remove(item) {
      //let self = this;
      this.confirm = false;
      this.dialog = false;
      let startReorder = false;
      this.$store.dispatch("setLoading", true);
      let delRef = null;
      let updateArray = [];
      console.log(item);

      this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course)
        .collection("units")
        .doc(this.$route.params.unit)
        .collection("steps")
        .orderBy("itemOrder")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            if (doc.id == item[".key"]) {
              delRef = doc.ref;
              startReorder = true;
            } else if (startReorder) {
              updateArray.push(doc);
            }
          });
          var batch = this.$store.getters.db.batch();
          batch.delete(delRef);
          updateArray.forEach(doc => {
            batch.update(doc.ref, { itemOrder: doc.data().itemOrder - 1 });
          });

          batch.commit().then(() => {
            console.log("Step successfully deleted!");
            this.$store.dispatch("sendNotification", {
              snackbar: true,
              color: "error",
              timeout: 6000,
              text: "Step deleted"
            });
            this.$store.dispatch("setLoading", false);
            this.$router.push({
              path:
                "/admin/courses/" +
                this.$route.params.course +
                "/" +
                this.$route.params.unit
            });
          });
        })
        .catch(function(error) {
          console.log("Error getting documents: ", error);
        });
    },
    close() {
      this.$store.dispatch("sendNotification", {
        snackbar: true,
        color: "red darken-2",
        text: this.item.name + " not saved"
      });
      this.dialog = false;
    }
  }
};
</script>
